import { useEffect } from 'react';

/**
 * Closes a menu/dropdown when the user clicks anywhere outside.
 * Replaces the repeated document click listener pattern across pages.
 *
 * @param {boolean}  isOpen  - whether the menu is currently open
 * @param {Function} onClose - called when an outside click occurs
 *
 * Usage:
 *   useMenuClose(!!openMenuId, () => setOpenMenuId(null));
 */
export function useMenuClose(isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = () => onClose();
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [isOpen, onClose]);
}
